import { combineEpics, ofType } from 'redux-observable';
import { debounceTime, map, switchMap } from 'rxjs/operators';
import { from } from 'rxjs';
import { setPinProjects, setProjectStatusCount, setProjects, setRecentProjects } from '../store/dashboard/ProjectsSlice';
import { GetMyProjectsPayload } from '../models/Myprojects';
import useProjectFacade from '../facade/project.Facade';

const fetchProjectsEpic = (action$: any) =>
    action$.pipe(
        ofType('myProjects/getMyProjects'),
        debounceTime(500),
        switchMap((actionData: GetMyProjectsPayload) => {
            return from(useProjectFacade().loadProjects(actionData)).pipe(
                map(projects => setProjects(projects))
            );
        })
    );

const fetchPinProjectEpic = (action$: any) =>
    action$.pipe(
        ofType('myProjects/getPinProjects'),
        switchMap(() => {
            return from(useProjectFacade().loadPinProject()).pipe(
                map(projects => setPinProjects(projects))
            );
        })
    );

const fetchRecentProjectEpic = (action$: any) =>
    action$.pipe(
        ofType('myProjects/getRecentProjects'),
        switchMap(() => {
            return from(useProjectFacade().loadRecentProjects()).pipe(
                map(projects => setRecentProjects(projects))
            );
        })
    );

    const fetchOtherProjectsEpic = (action$: any) =>
        action$.pipe(
            ofType('myProjects/getOtherProjects'),
            debounceTime(500),
            switchMap((actionData: GetMyProjectsPayload) => {
                return from(useProjectFacade().loadOtherProject(actionData)).pipe(
                    map(projects => setProjects(projects))
                );
            })
        );

const copyMyProjectEpic = (action$: any) =>
    action$.pipe(
        ofType("myProjects/getCopyProjects"),
        switchMap((actionData: GetMyProjectsPayload) => {
            let payload: any;
            return from(useProjectFacade().copyMyProjects(payload)).pipe(
                map((projects) => {
                    if (projects) {
                        from(useProjectFacade().loadProjects(actionData)).pipe(
                            map((projects) => setProjects(projects))
                        );
                    }
                })
            );
        })
    );

const removeMyProjectEpic = (action$: any) => 
    action$.pipe(
        ofType('myProjects/removeMyProjects'),
        switchMap((actionData: any) => {
            let payload: any;
            return from(useProjectFacade().removeMyProjects(payload)).pipe(
                map((projects) => {
                    if (projects) {
                        from(useProjectFacade().loadProjects(actionData)).pipe(
                            map((projects) => setProjects(projects))
                        );
                    }
                })
            );
        })
    );

 const fetchProjectStatusEpic = (action$: any) =>
    action$.pipe(
        ofType('myProjects/GetProjectStatusCount'),
        switchMap(() => {
            return from(useProjectFacade().loadProjectStatus()).pipe(
                map(projects => setProjectStatusCount(projects)
                )
            );
        })
    );



export const projectEpic = combineEpics(
    fetchProjectsEpic,
    fetchPinProjectEpic,
    fetchRecentProjectEpic,
    fetchOtherProjectsEpic,
    copyMyProjectEpic,
    removeMyProjectEpic,
    fetchProjectStatusEpic
);

